import React from 'react';
import Modal from 'components/shared/modals/Modal'
import { ReactComponent as IconInfo } from 'images/info-circle-o.svg';
import Button from 'components/shared/Button';
import { format } from 'date-fns';
import clsx from 'clsx';
import s from './InfoModal.module.scss';

type Props = {
  isOpen: boolean
  onClose: () => void
  post?: any
}

function InfoModal({
  isOpen,
  onClose,
  post,
}: Props) {
  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      onClick={(e: any) => e.stopPropagation()}
      className={clsx(s.infoModal, 'swiper-no-swiping')}
    >
      <div
        className={s.container}
        onWheel={(e: any) => {
          e.stopPropagation()
          e.preventDefault()
          e.nativeEvent.stopPropagation()
          e.nativeEvent.stopImmediatePropagation()
        }}
      >
        <IconInfo />
        <div className={s.innerBody}>
          <h2 className={s.title}>Important Note</h2>
          <div className={s.text}>
            This content is for educational purposes only.
            The information contained herein does not constitute financial advice,
            nor is it considered representative of the views and opinions of Beautify.
            Please act responsibly.
          </div>
          {
            post ? (
              <div className={s.timeBody}>
                <h2 className={s.title}>Video posting time</h2>
                <div className={s.text}>
                  {format(new Date(post?.created_at), 'MMMM dd yyyy')}
                </div>
              </div>
            ) : null
          }
        </div>
        <Button className={s.purpleBtn} onClick={onClose}>
          I Understand
        </Button>
      </div>
    </Modal>
  )
}

export default InfoModal
